<script setup lang="ts">
import postToJdoodleService from '@/services/embeds/plugin/post.to.jdoodle.service'
import LogoBlack from '@/assets/images/JD_logo_colour.webp'

/**
 * Posts the code to JDoodle
 */
const postToJDoodle = () => {
  postToJdoodleService.postToJDoodle()
}
</script>

<template>
  <div class="flex max-h-12 items-center justify-between">
    <p class="p-small">
      <a @click="postToJDoodle" class="link-secondary">Edit this program in JDoodle.com</a>
    </p>
    <a
      href="https://www.jdoodle.com"
      target="_blank"
      class="flex items-center gap-2 rounded-lg p-2"
    >
      <span class="p-small">Online compiler powered by</span>
      <img class="h-12 w-fit" :src="LogoBlack" alt="JDoodle" />
    </a>
  </div>
</template>
